import axios from "axios";
import React, {useEffect, useState} from 'react'
import Footer from "./parts/footer";
import CustomGallery from "./gallery/gallery";
import Formats from "./formats/formats";
import AdvantagesOne from "./advantages/advantages";
import Awarding from "./awarding/awarding";
import EbAutOne from "./ebaut-event/ebaut";
import Header from "./parts/header";
import EventThemesBase from "./themes/themes-base";
import EventSpeacersBase from "./speacers/speacers-base"
import EventPartnersBase from "./partners/partners-base"
import PartnersTopNew from "./partners/partners-top-new"
import EventPanelBase from "./panel/panel-base";
import EventProgram from "./program/program-accordion"
import FirstScreen from "./first-screen/firstscreen";
import EventOrganizers from "./organizers/organizers"
import EventVideo from "./video/video"
import OldSpeacers from "./speacers/speacers-old";
import Statistic from "./statistic/statistic";
import Quotes from "./speaker-quotes/quotes";
import EventPanelNew from "./panel/panel-new";
import News from "./news/news";


function Home() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/4510?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    let advantagesData = post.advantages
    let ebautData = post.ebaut_event
    let fsData = post.fs_group
    let formatsData = post.formats
    let myGallery = post.gallery
    let awardingData = post.awarding
    let speacersData = post.speacers
    let partnersBaseData = post.partners_bottom
    let partnersTopData = post.partners_top_new
    let panelData = post.panel
    let themesData = post.theme
    let programData = post.program

    return (
        <>
            <Header/>
            <FirstScreen fsData={fsData} />
            <Statistic />
            <Quotes />

            <EbAutOne ebautData={ebautData} />
            <CustomGallery myGallery={myGallery} />
            <EventThemesBase />
            <EventSpeacersBase speacersData={speacersData} />
            <EventProgram programData={programData} />
            <Formats formatsData={formatsData} />
            <News />
            {<EventOrganizers/>}



            {/*<AdvantagesOne advantagesData={advantagesData} />*/}
            {/*<EventPanelNew />*/}
            {/*<OldSpeacers />*/}
            {/*<EventPanelBase panelData ={panelData}  />*/}
            {/*<Awarding awardingData={awardingData} />*/}
            
            {/*<PartnersTopNew partnersTopData={partnersTopData} />*/}

            <EventPartnersBase partnersBaseData={partnersBaseData}/>
            <Footer />
        </>
    )
}

export default Home;